import { createSelectorDeep } from './misc';
import { routesLocalFirst } from 'utils/sort';
import _ from 'lodash';

const getRoutes = (state) => state.routes;
const getFilter = (state, filter) => filter;

const ROUTES_FOR_FILTERS = [
  'ALG',
  'BCN',
  'LEE',
  'LIL',
  'LIV',
  'LON',
  'LYN',
  'MAD',
  'PAR',
  'PVC',
  'VLC',
  'PVA',
  'CAS',
  'ZAZ',
  'BCN-_FR',
  'ALG-_PT',
  'VLC-CAS',
  'CAS-VLC',
];

export const makeRoutePairs = (routes) => {
  return routes
    .sort(routesLocalFirst)
    .filter(
      (val, index, arr) => arr.findIndex((el) => el.symmetric_name === val.symmetric_name) === index
    ); // almost uniq
};

export const isLocalOrCorridorAndDefinedAndEnabled = (route) => {
  return route.local && route.defined && ROUTES_FOR_FILTERS.includes(route.simple_name);
};

export const getAllRoutes = createSelectorDeep([getRoutes], (routes) =>
  routes.sort(routesLocalFirst)
);

export const getAllRouteNames = createSelectorDeep([getAllRoutes], (routes) =>
  routes.map((route) => route.name)
);

export const getFilteredRoutes = createSelectorDeep([getAllRoutes, getFilter], (routes, filter) =>
  routes.filter(filter)
);

export const getFilteredRouteNames = createSelectorDeep([getFilteredRoutes], (routes) =>
  routes.map((route) => route.name)
);

export const getAllRoutePairs = createSelectorDeep([getAllRoutes], makeRoutePairs);

export const getAllRoutePairNames = createSelectorDeep([getAllRoutes], (routes) =>
  routes.map((route) => route.symmetric_name)
);

export const getAllRouteCountries = createSelectorDeep([getAllRoutes], (routes) =>
  _.uniq(routes.map((route) => route.country))
);
